import React from 'react';
import { Link } from 'react-router-dom';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

const lexend = '"Lexend", sans-serif';

const sectionStyle = {
  fontFamily: lexend,
  fontOpticalSizing: 'auto',
  marginBottom: '1.5rem',
};

const headingStyle = {
  fontFamily: lexend,
  fontOpticalSizing: 'auto',
  fontWeight: 700,
  color: '#1c3dfe',
  marginBottom: '0.5rem',
};

export default function PrivacyPage() {
  return (
    <>
      <SiteHeader />
      <main style={{
        paddingTop: '100px',
        paddingBottom: '3rem',
        minHeight: '100vh',
        background: '#fff',
      }}>
        <article style={{
          maxWidth: '720px',
          margin: '0 auto',
          padding: '2rem 2rem 4rem',
        }}>
          <h1 style={{
            ...headingStyle,
            fontSize: 'clamp(1.75rem, 4vw, 2.25rem)',
            marginBottom: '0.25rem',
          }}>
            Privacy Policy – NearStay
          </h1>
          <p style={{ ...sectionStyle, color: '#666', fontSize: '0.95rem' }}>
            Last updated: 16 February 2026
          </p>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            NearStay (“we”, “our”, “us”) respects your privacy. This Privacy Policy explains how we collect, use, and protect your information when you join the NearStay waitlist or visit our website.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>1. Information We Collect</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            When you sign up to the NearStay waitlist, we may collect:
          </p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Your email address</li>
            <li>Your name (if provided)</li>
            <li>Basic analytics data (e.g. page visits, device type, country, referral source)</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We only collect information that is necessary to operate and improve NearStay.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>2. How We Use Your Information</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We use your information to:
          </p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Notify you about NearStay updates, early access, and product launches</li>
            <li>Understand interest in NearStay and improve the product</li>
            <li>Communicate important changes or announcements</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We will not sell your personal data.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>3. How We Store and Protect Your Data</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            Your data is stored securely using reputable third-party services (e.g. form providers, email tools, analytics platforms).
            We take reasonable steps to protect your data, but no system is 100% secure.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>4. Third-Party Services</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We may use trusted third-party tools to:
          </p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Collect waitlist signups</li>
            <li>Send emails</li>
            <li>Track basic analytics</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            These services only receive the minimum data needed to perform their function and are required to handle your data responsibly.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>5. Cookies & Analytics</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We may use cookies or similar technologies to:
          </p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Understand how people use our site</li>
            <li>Improve the website experience</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            You can disable cookies in your browser settings if you prefer.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>6. How Long We Keep Your Data</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We keep your data only for as long as necessary to:
          </p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Operate the waitlist</li>
            <li>Launch and run NearStay</li>
            <li>Meet legal or operational requirements</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            You can ask us to delete your data at any time.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>7. Your Rights</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            Depending on your location, you may have rights to:
          </p>
          <ul style={{ ...sectionStyle, paddingLeft: '1.5rem', lineHeight: 1.7, color: '#333' }}>
            <li>Access your data</li>
            <li>Correct your data</li>
            <li>Request deletion of your data</li>
            <li>Withdraw consent to receive emails</li>
          </ul>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            You can exercise these rights by contacting us.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>8. Children’s Privacy</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            NearStay is not intended for children under 13.
            We do not knowingly collect personal data from children.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>9. Changes to This Policy</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            We may update this Privacy Policy from time to time.
            If we make significant changes, we’ll update the date at the top of this page.
          </p>

          <h2 style={{ ...headingStyle, fontSize: '1.25rem' }}>10. Contact</h2>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            If you have questions about this Privacy Policy or your data, contact:
          </p>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            Email: <a href="mailto:garethpower92@gmail.com" style={{ color: '#1c3dfe', textDecoration: 'underline' }}>garethpower92@gmail.com</a>
          </p>
          <p style={{ ...sectionStyle, lineHeight: 1.6, color: '#333' }}>
            Website: <a href="https://nearstay.co" target="_blank" rel="noopener noreferrer" style={{ color: '#1c3dfe', textDecoration: 'underline' }}>https://nearstay.co</a>
          </p>

          <p style={{ marginTop: '2.5rem' }}>
            <Link to="/" style={{ color: '#1c3dfe', textDecoration: 'underline', fontFamily: lexend }}>
              ← Back to NearStay
            </Link>
          </p>
        </article>
      </main>
      <SiteFooter />
    </>
  );
}
